
import Vue from "vue";
import * as models from "@/code/models";
import * as Emp from "@/code/apis/api.employee";
import jwt_decode from "jwt-decode";

export default Vue.extend({
  name: "myNav",
  data: () => ({
    tok: [] as any,
    currentbody: [] as any,
    mins: [
      { title: "My Profile", path: "/profile" },
      { title: "Settings" },
      { title: "Logout", path: "/login" },
    ],
  }),
  methods: {
    toggle() {
      const that = this as any;
      const val = that.$vuetify.breakpoint.name;
      let drawer = Object.assign({}, that.$store.state.drawerAll); // copy of the object
      if (val == "xs" || val == "sm" || val == "md") {
        drawer.view = !drawer.view;
      } else {
        drawer.mini = !drawer.mini;
      }
      that.$store.commit("get_drawer", drawer);
    },
    getIntEmployee: async function () {
      const token = localStorage.getItem("token");
      if (token) {
        const decoded = jwt_decode(token);
        let that = this as any;
        console.log(decoded);
        this.tok = decoded;
        console.log(that.tok.id);
      }
      const result = await Emp.Employee.getonceEmployee(this.tok.id, true);
      if (result.ok && result.body) {
        //
        const body = result.body;
        this.$store.commit("get_intemployees", body);
        this.currentbody = this.$store.state.currentUser;
        console.log(this.currentbody);
      } else {
        // there is something wrong
        console.log("falseee");
      }
    },
  },
  created() {
    this.getIntEmployee();
  },
});
